import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Sidebar.css';

interface SidebarProps {
  isOpen?: boolean;
  onClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen = false, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen || !onClose) return;
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    onClose?.();
  };

  return (
    <>
      {isOpen && (
        <div
          className="sidebar-backdrop"
          onClick={onClose}
          aria-label="Close menu"
        />
      )}
      <aside className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <nav className="sidebar-nav">
          <div className="nav-section">
            <div className="nav-section-title">MEASUREMENTS</div>
            <div
              className={`nav-item ${isActive('/measurements') ? 'active' : ''}`}
              onClick={() => handleNavigation('/measurements')}
            >
              Measurements
            </div>
            <div
              className={`nav-item ${isActive('/create-measurement') ? 'active' : ''}`}
              onClick={() => handleNavigation('/create-measurement')}
            >
              Create measurement
            </div>
          </div>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
